import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { UserAuthRole } from 'lemunzo-api';
import { ErrorComponent, RoleGuard } from 'lemunzo-shared';

export const routes: Routes = [
    {
        path: 'auth',
        loadComponent: () =>
            import('./auth/auth.component').then((c) => c.AuthComponent),
        canActivate: [MsalGuard],
    },
    {
        path: 'admin',
        loadChildren: () =>
            import('./admin/admin.routes').then((r) => r.routes),
        canActivate: [MsalGuard, RoleGuard],
        data: {
            roles: [
                UserAuthRole.Member,
                UserAuthRole.Admin,
                UserAuthRole.SuperAdmin,
            ],
        },
    },
    {
        path: 'logout',
        loadComponent: () =>
            import('./auth/logout/logout.component').then(
                (c) => c.LogoutComponent
            ),
    },
    {
        path: 'error',
        component: ErrorComponent,
    },
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'auth',
    },
    {
        path: '**',
        component: ErrorComponent,
    },
];
